
import { Button } from "@mui/material";
import { useLogin } from "../../hooks/useLogin";

export const LoginComp = () => {
  const { handleLogin } = useLogin();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 50,
      }}
    >
      <div style={{ marginBottom: 20, fontSize: 18 }}>
        Please login to add movies to watchlist and favorites
      </div>
      <Button variant="contained" onClick={handleLogin}>
        Login
      </Button>
    </div>
  );
};
